/* istanbul ignore file */

import { render as renderProductInformationHeader } from './components/product-information-header'
import commonTemplate from '../common/template'

const productInformationHeader = (basicPlan, selectedPlanName, selectedPlanCode, redLine, sumAssured) =>
  renderProductInformationHeader(basicPlan, selectedPlanName, selectedPlanCode, redLine, sumAssured)

const template = async (props) => {
  const { basicPlan, selectedPlanName, selectedPlanCode, redLine, sumAssured } = props
  const header = productInformationHeader(basicPlan, selectedPlanName, selectedPlanCode, redLine, sumAssured)
  return commonTemplate(props, header)
}

export default template
